// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import LogoutButton from "../components/LogoutButton";
import {
  AiOutlineTeam,
  AiOutlineEdit,
  AiOutlineUnorderedList,
  AiOutlineCar,
  AiOutlineBarChart,
  AiOutlineUserAdd,
  AiOutlineDollarCircle,
  AiOutlineFileText,
  AiOutlineCloudUpload,
  AiOutlineMail,
  AiOutlineSetting,
} from "react-icons/ai";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user?.role !== "user" || !user?.id) return;

    const token = localStorage.getItem("token");

    fetch(`/api/messages/${user.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) throw new Error("Unexpected data");
        const unread = data.filter((m) => !m.read_at).length;
        setUnreadCount(unread);
      })
      .catch((err) => {
        console.error("Помилка при завантаженні повідомлень:", err);
      });
  }, [user]);



  const changeLanguage = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };

  return (
    <header className="p-3 bg-white text-dark">
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <Link to="/" className="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none">
            <h3 className="m-0 me-3">Go Drive Partner</h3>
          </Link>

          <ul className="nav me-auto align-items-right">
            {user?.role === "admin" ? (
              <Dropdown className="me-2">
                <Dropdown.Toggle variant="white" id="dropdown-basic">
                  {t("adminHeader")}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="/admin/users"><AiOutlineTeam className="me-2" />{t("users")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/fleet"><AiOutlineCar className="me-2" />{t("fleet.title")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/import-data">{t("dataImport")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/upload-incomings">{t("uploadUberBolt")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/edit-source-data/"><AiOutlineEdit className="me-2" />{t("editIncomes")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-debts">{t("driverDebts")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-extra-funds">{t("extraCosts")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/extra-funds-default-values" className="ps-4"><AiOutlineUnorderedList className="me-2" />{t("standardValues")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-raport">{t("raports")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/reports-table">- Reports Table</Dropdown.Item>
                  <Dropdown.Item href="/admin/check-reports">- {t("checkreport")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/monthly-reports">📅 {t("monthlyReports")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/month-summary">📊 Місячна статистика</Dropdown.Item>
                  <Dropdown.Item href="/admin/generate-invoice">📄 Генерація рахунку</Dropdown.Item>
                  <Dropdown.Item href="/admin/ksef">📋 KSeF — фактури</Dropdown.Item>
                  <Dropdown.Item href="/admin/driver-invoices/new">📄 Додати фактуру водія</Dropdown.Item>
                  <Dropdown.Item href="/admin/cash-stats">{t("cashRaports")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/week-statistics"><AiOutlineBarChart className="me-2" />{t("weekStatisticsTitle")}</Dropdown.Item>
                  <Dropdown.Item href="/settings">{t("usersettings")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/settings">{t("sitesettings")}</Dropdown.Item>
                  <Dropdown.Item href="/admin/messages/all">{t("messages")}</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <>
                <Button variant="light" className="me-2" href="/">{t("raports")}</Button>
                <Button
                  variant="light"
                  href="/user/messages"
                  className={`position-relative ${unreadCount > 0 ? "fw-bold" : ""}`}
                >
                  {t("messages")} {unreadCount > 0 && `(${unreadCount})`}

                  {unreadCount > 0 && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                      style={{ fontSize: "0.6rem" }}
                    ></span>
                  )}
                </Button>
                <Button variant="light" href="/user/my-invoices" className="me-2">
                  {t("myInvoices")}
                </Button>
                <Button variant="light" href="/user/upload-invoice">
                  {t("addInvoice")}
                </Button>
              </>


            )}
          </ul>

          {/* Мова + вихід */}
          <div className="d-flex align-items-center ms-auto">
            {user && (
              <div className="ms-3">
                <span className="me-2">{t("hello")}, {user.firstName}!</span>
              </div>
            )}
            <select
              onChange={changeLanguage}
              value={i18n.language}
              className="form-select w-auto me-2"
            >
              <option value="ua">UA</option>
              <option value="en">EN</option>
              <option value="pl">PL</option>
              <option value="ru">RU</option>
            </select>

            <div className="me-2">
              <LogoutButton />
            </div>
          </div>
        </div>

        {/* Горизонтальне випадаюче меню для адміністратора з іконками і текстом */}
        {user?.role === "admin" && (
          <div className="mt-2 d-flex flex-wrap align-items-stretch gap-2 w-100">
            {/* Користувачі */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-users-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineTeam className="me-1" />
                <span>Користувачі</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/users">
                  <AiOutlineTeam className="me-2" />
                  Список користувачів
                </Dropdown.Item>
                <Dropdown.Item href="/admin/addnewuser">
                  <AiOutlineUserAdd className="me-2" />
                  Додати користувача
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Автопарк */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-fleet-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineCar className="me-1" />
                <span>Автопарк</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/fleet">
                  <AiOutlineCar className="me-2" />
                  Список авто
                </Dropdown.Item>
                <Dropdown.Item href="/admin/fleet/new">
                  <AiOutlineCar className="me-2" />
                  Додати авто
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Фінанси */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-finance-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineDollarCircle className="me-1" />
                <span>Фінанси</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/driver-extra-funds">
                  <AiOutlineDollarCircle className="me-2" />
                  Додаткові кошти
                </Dropdown.Item>
                <Dropdown.Item href="/admin/driver-debts">
                  <AiOutlineBarChart className="me-2" />
                  Борги
                </Dropdown.Item>
                <Dropdown.Item href="/admin/driver-raport">
                  <AiOutlineBarChart className="me-2" />
                  Рапорти
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Звіти */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-reports-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineBarChart className="me-1" />
                <span>Звіти</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/reports-table">
                  <AiOutlineBarChart className="me-2" />
                  Таблиця рапортів
                </Dropdown.Item>
                <Dropdown.Item href="/admin/check-reports">
                  <AiOutlineBarChart className="me-2" />
                  Перевірка рапортів
                </Dropdown.Item>
                <Dropdown.Item href="/admin/monthly-reports">
                  <AiOutlineBarChart className="me-2" />
                  Місячні рапорти
                </Dropdown.Item>
                <Dropdown.Item href="/admin/month-summary">
                  <AiOutlineBarChart className="me-2" />
                  Місячна статистика
                </Dropdown.Item>
                <Dropdown.Item href="/admin/week-statistics">
                  <AiOutlineBarChart className="me-2" />
                  Щотижнева статистика
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Імпорт */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-import-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineCloudUpload className="me-1" />
                <span>Імпорт</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/import-data">
                  <AiOutlineCloudUpload className="me-2" />
                  Імпорт даних
                </Dropdown.Item>
                <Dropdown.Item href="/admin/upload-incomings">
                  <AiOutlineCloudUpload className="me-2" />
                  Завантаження доходів
                </Dropdown.Item>
                <Dropdown.Item href="/admin/incoming-preview/uber">
                  <AiOutlineFileText className="me-2" />
                  Попередній перегляд
                </Dropdown.Item>
                <Dropdown.Item href="/admin/edit-source-data">
                  <AiOutlineEdit className="me-2" />
                  Редагування сирих даних
                </Dropdown.Item>
                <Dropdown.Item href="/instructions">
                  <AiOutlineUnorderedList className="me-2" />
                  Інструкції
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Рахунки */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-invoices-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineFileText className="me-1" />
                <span>Рахунки</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/generate-invoice">
                  <AiOutlineFileText className="me-2" />
                  Генерація рахунку
                </Dropdown.Item>
                <Dropdown.Item href="/admin/ksef">
                  <AiOutlineFileText className="me-2" />
                  KSeF — фактури
                </Dropdown.Item>
                <Dropdown.Item href="/admin/driver-invoices/new">
                  <AiOutlineFileText className="me-2" />
                  Додати фактуру водія
                </Dropdown.Item>
                <Dropdown.Item href="/admin/driver-invoices">
                  <AiOutlineFileText className="me-2" />
                  Фактури водіїв
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Повідомлення */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-messages-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineMail className="me-1" />
                <span>Повідомлення</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/messages">
                  <AiOutlineMail className="me-2" />
                  Нове повідомлення
                </Dropdown.Item>
                <Dropdown.Item href="/admin/messages/all">
                  <AiOutlineMail className="me-2" />
                  Усі повідомлення
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Налаштування */}
            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                variant="light"
                size="sm"
                id="admin-settings-menu"
                className="w-100 d-flex align-items-center justify-content-center"
              >
                <AiOutlineSetting className="me-1" />
                <span>Налаштування</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/admin/settings">
                  <AiOutlineSetting className="me-2" />
                  Налаштування сайту
                </Dropdown.Item>
                <Dropdown.Item href="/settings">
                  <AiOutlineSetting className="me-2" />
                  Мої налаштування
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
